import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Load the list of users that can be assigned as technicians in service forms.
 * Returned array contains admins + technicians (admins can also do visits).
 * Each item: { id, email, name, role }
 */
export default function useTechnicians() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api.get("/users/technicians")
      .then(({ data }) => { if (alive) setItems(data || []); })
      .catch(() => { if (alive) setItems([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { items, loading };
}
